import styles from './index.module.less';
import { FC, useEffect, useState } from 'react';
import cn from 'classnames';
import { IGifts, IGift } from 'base/interfaces/product';

type IProps = IGifts['activity'] & {
    onShowDetail: () => void;
    checkedGift: IGift;
};

export const ProdGiftsTip: FC<IProps> = props => {
    const {
        title,
        triggerText,
        onShowDetail,
        checkedGift,
    } = props;

    return !checkedGift ? null : (
        <div className={styles.tip}>
            <div className="flex flex-justify">
                <strong className={styles.title}>{title}</strong>
                <span className={styles.trigger} onClick={onShowDetail}>{triggerText}</span>
            </div>
            <div className={styles.desc} dangerouslySetInnerHTML={{ __html: checkedGift.tip }}/>
        </div>
    )
};